import { Measurement } from '../../../../BaggageService/types';
export function convertIncludedBaggageToSelected(travellerId, includedService) {
    var _a;
    const { serviceId, segmentIds, confirmedCount, service } = includedService;
    const baggageService = service;
    const baggage = {
        id: serviceId,
        includedSegments: segmentIds,
        included: confirmedCount,
        segmentIds: baggageService.allowedSegments,
        type: baggageService.baggageType,
        name: baggageService.name,
        description: baggageService.description,
        value: {
            amount: parseInt((_a = baggageService.baggageWeight) === null || _a === void 0 ? void 0 : _a.split('x')[0]),
            measurement: Measurement.Kilograms
        },
        size: baggageService.size,
        price: baggageService.price,
        rfics: baggageService.rfisc,
        canBeAdded: false,
        allowedPassengers: [travellerId],
        isReplacedBy: baggageService.isReplacedBy
    };
    return Object.assign(Object.assign({}, includedService), { baggage, passengerId: travellerId });
}
